import { Checkbox, Modal, Radio, Typography } from "antd";
import type { PrintModeloAnaliseQualidade, PrintOptionsAnaliseQualidade } from "./printOptions";

const { Text } = Typography;

export function PrintOptionsModal({
	open,
	value,
	onChange,
	onCancel,
	onConfirm,
}: {
	open: boolean;
	value: PrintOptionsAnaliseQualidade;
	onChange: (next: PrintOptionsAnaliseQualidade) => void;
	onCancel: () => void;
	onConfirm: () => void;
}) {
	return (
		<Modal
			title="Modelo de impressão"
			open={open}
			okText="Imprimir"
			cancelText="Cancelar"
			onOk={onConfirm}
			onCancel={onCancel}
		>
			<Text type="secondary" className="mb-3 block">
				Escolha como o relatório sai no papel. A ordem das colunas na tela (clique no título) é mantida na
				impressão. Na aba Por rota, use &quot;Por rota, com nomes dos produtores&quot; para sair igual à tela.
			</Text>

			<Radio.Group
				value={value.modelo}
				onChange={(event) => onChange({ ...value, modelo: event.target.value as PrintModeloAnaliseQualidade })}
				className="flex flex-col gap-2 mb-3"
			>
				<Radio value="produtores">Todos os produtores (lista corrida)</Radio>
				<Radio value="rotas-produtores">Por rota, com nomes dos produtores</Radio>
				<Radio value="rotas-totais">Por rota, só totais (sem nomes)</Radio>
			</Radio.Group>

			<Checkbox
				checked={value.incluirResumo}
				onChange={(event) => onChange({ ...value, incluirResumo: event.target.checked })}
			>
				Incluir cards de resumo
			</Checkbox>
		</Modal>
	);
}
